<template>
    <div class="px-8">
        <div class="flex flex-col mt-4">
            <div class="-my-2 sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th @click="sortBy('gin')" :class="{'font-extrabold' : sortKey === 'gin' }" scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        <div class="cursor-pointer flex items-center justify-between">
                                            <span>Gin</span>
                                            <span v-if="sortKey === 'gin'">
                                                <svg :class="{'transform rotate-180' : sortOrder === 'desc' }" class="w-4 h-4 ml-1 transition duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"></path></svg>
                                            </span>
                                        </div>
                                    </th>
                                    <th @click="sortBy('quantity')" :class="{'font-extrabold' : sortKey === 'quantity' }" scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        <div class="cursor-pointer flex items-center justify-between">
                                            <span>Qty</span>
                                            <span v-if="sortKey === 'quantity'">
                                                <svg :class="{'transform rotate-180' : sortOrder === 'desc' }" class="w-4 h-4 ml-1 transition duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"></path></svg>
                                            </span>
                                        </div>
                                    </th>
                                    <th @click="sortBy('percentage')" :class="{'font-extrabold' : sortKey === 'percentage' }" scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        <div class="cursor-pointer flex items-center justify-between">
                                            <span>Percentage</span>
                                            <span v-if="sortKey === 'percentage'">
                                                <svg :class="{'transform rotate-180' : sortOrder === 'desc' }" class="w-4 h-4 ml-1 transition duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"></path></svg>
                                            </span>
                                        </div>
                                    </th>
                                    <th @click="sortBy('total_bale_estimate')" :class="{'font-extrabold' : sortKey === 'total_bale_estimate' }" scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        <div class="cursor-pointer flex items-center justify-between">
                                            <span>Bale Est.</span>
                                            <span v-if="sortKey === 'total_bale_estimate'">
                                                <svg :class="{'transform rotate-180' : sortOrder === 'desc' }" class="w-4 h-4 ml-1 transition duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"></path></svg>
                                            </span>
                                        </div>
                                    </th>
                                    <th @click="sortBy('bid')" :class="{'font-extrabold' : sortKey === 'bid' }" scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        <div class="cursor-pointer flex items-center justify-between">
                                            <span>Bid</span>
                                            <span v-if="sortKey === 'bid'">
                                                <svg :class="{'transform rotate-180' : sortOrder === 'desc' }" class="w-4 h-4 ml-1 transition duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"></path></svg>
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" class="relative px-6 py-3">
                                        <span class="sr-only">View</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, idx) in sortedCottonseedBid" :class="{ 'bg-white' : idx % 2 === 0, 'bg-gray-50' : idx % 2 !== 0, 'bg-blue-50' : showMenu === item.id }">
                                    <td class="px-6 py-4 text-gray-800 ">
                                        <p class="text-sm overflow-ellipsis overflow-hidden">{{ item.gin }}</p>
                                    </td>
                                    <td class="px-6 py-4 text-gray-800 ">
                                        <p class="text-sm overflow-ellipsis overflow-hidden">{{ item.quantity }}</p>
                                    </td>
                                    <td class="px-6 py-4 text-gray-800 ">
                                        <p class="text-sm overflow-ellipsis overflow-hidden">{{ item.percentage | currency }}</p>
                                    </td>
                                    <td class="px-6 py-4 text-gray-800 ">
                                        <p class="text-sm overflow-ellipsis overflow-hidden">{{ item.total_bale_estimate }}</p>
                                    </td>
                                    <td class="px-6 py-4 text-gray-800 ">
                                        <p class="text-sm overflow-ellipsis overflow-hidden">{{ item.bid_id }}</p>
                                    </td>
                                    <td class="px-6 py-4 align-top text-right text-sm font-medium">
                                        <inertia-link class="text-blue-800" :href="route('cottonseed-bids-acceptance', item.id)">View Acceptance</inertia-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            showMenu: null,
            sortKey: 'updated_at',
            sortOrder: 'desc',
        }
    },
    methods: {
        setShowMenu(id) {
            this.showMenu = this.showMenu === id ? null : id
        },
        sortBy(key) {
            this.sortKey = key
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
        },
        compareValues(key, order = 'asc') {
            return function innerSort(a, b) {
                if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;
                const comparison = a[key].localeCompare(b[key]);

                return (
                    (order === 'desc') ? (comparison * -1) : comparison
                );
            };
        }
    },
    computed: {
        sortedCottonseedBid() {
            return this.items.sort(
                this.compareValues(this.sortKey, this.sortOrder)
            )
        }
    }
}
</script>
